<div class="container" *ngIf="type != postulationState.NOSELECCIONADO">
  <h5 class="h5 mt">Complete your personal information</h5>
  <div class="image-container">
    <app-upload-image [url]="model.image" (fileChange)="model.__fileImage = $event" label="Cover Image" [model]="model"></app-upload-image>
  </div>

  <app-mat-form-field appearance='outline' [model]="model" [hideCleanButton]="true" label="{{'langs.crud_name' | translateWithKeys}}"
    property="name"></app-mat-form-field>

  <app-mat-form-field appearance='outline' [model]="model" [hideCleanButton]="true" label="{{'langs.crud_last_name' | translateWithKeys}}" property="lastName">
  </app-mat-form-field>

  <app-mat-form-field appearance='outline' [model]="model" [hideCleanButton]="true" label="{{'langs.dni' | translateWithKeys}}" property="dni">
  </app-mat-form-field>

  <app-mat-form-field appearance='outline' [model]="model" [hideCleanButton]="true" label="{{'langs.crud_email' | translateWithKeys}}"
    property="email"></app-mat-form-field>

  <app-mat-form-field appearance='outline' [model]="model" [hideCleanButton]="true" label="{{'langs.crud_phone' | translateWithKeys}}"
    property="phoneNumber"></app-mat-form-field>

  <div>
    <div class="image-container" style="margin-top: 0px;">
      <p>DNI front</p>
      <app-upload-image [url]="model.dniFront" (fileChange)="model.__dniFront = $event" label="Cover Image" [model]="model"></app-upload-image>
    </div>

    <div class="image-container" style="margin-top: 55px; margin-bottom: 60px;">
      <p>DNI back</p>
      <app-upload-image [url]="model.dniBack" (fileChange)="model.__dniBack = $event" label="Cover Image" [model]="model"></app-upload-image>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="16px">
    <button mat-raised-button class="primary-color" (click)="save()">Save</button>
  </div>
</div>

<div class="container" *ngIf="type == postulationState.NOSELECCIONADO">
  <h5 class="h5 mt">Leave us your feedback
  </h5>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>Leave a comment</mat-label>
    <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" matInput [(ngModel)]="model.rejectNote" disabled="{{isDisable}}"></textarea>
  </mat-form-field>

  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="16px">
    <button mat-raised-button class="primary-color" (click)="save()" disabled="{{isDisable}}">Save</button>
  </div>
</div>
